// Phase 2 — Contracts v2 public signer page.
//
// Hosted at `/portal/sign/:envelopeId?t=<rawToken>`. Intentionally
// NOT mounted under `/patient-portal/*` because the wrapping
// PatientAuthQuery layout would require a Google OAuth session;
// the single-use signed token IS the credential for this surface.

import { lazy, Suspense } from "react";
import { Spin } from "antd";

// Lazy so importing SignerLoadingShell eagerly (from index.tsx's
// PublicCatchAllDispatcher) does NOT drag react-pdf/pdfjs into the funnel's
// main bundle. SignerApp renders only inside the <Suspense> below.
// See docs/infrastructure/CLIENT_BUNDLE_ARCHITECTURE.md.
const SignerApp = lazy(
  () => import("../../components/patient-portal/contracts/SignerApp"),
);

// Full-viewport loader so the patient never sees a flash of the
// quote-funnel landing page while the route's initial Relay query
// suspends. Exported so the /* catch-all dispatcher in index.tsx
// can reuse the same loading state when it intercepts
// /portal/sign/* URLs at the splat level.
export const SignerLoadingShell = () => (
  <div
    style={{
      minHeight: "100vh",
      // Keep in sync with SIGNER.canvas (components/patient-portal/contracts/
      // signerTheme.ts). A literal on purpose: this file is imported eagerly
      // from index.tsx, so it takes nothing from the lazy signer folder.
      backgroundColor: "#f1f5f9",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 16,
    }}
  >
    <Spin size="large" />
    <div style={{ color: "#666", fontSize: 14 }}>Loading your contract…</div>
  </div>
);

const SignEnvelopePage = () => (
  <Suspense fallback={<SignerLoadingShell />}>
    <SignerApp />
  </Suspense>
);

export default SignEnvelopePage;
